import { useCallback, useEffect, useState } from 'react'
import { info } from '../services/sentryLogger'

export const rewriteLocation = (newSubPath?: string) => {
    const { location, history } = window
    newSubPath = newSubPath ?? location.pathname
    history.replaceState({}, '', location.origin + newSubPath)
}
export const redirect = (url: string) => {
    const { location, history } = window
    location.replace(url)
}

export function useURLParams(...paramsNames: string[]) {
    const { location } = window
    const [result, setResult] = useState<Record<string, string>>({})
    const [loading, setLoading] = useState(true)

    const detectUrlParams = useCallback(() => {
        if (paramsNames) {
            const query = new URLSearchParams(location.search)
            const newResult: Record<string, string> = {}
            paramsNames.forEach((param) => {
                const value = query.get(param)
                if (param?.length && value?.length) {
                    newResult[param] = value
                    info('detectUrlParams', param, value)
                }
            })
            if (Object.keys(newResult).length) {
                setResult((oldResult) => ({
                    ...oldResult,
                    ...newResult,
                }))
                rewriteLocation(location.pathname)
            }
        }
        setLoading(false); // params have been detected (or not)
    }, [location, ...paramsNames])

    useEffect(() => detectUrlParams(), [detectUrlParams])
    return [result, loading]
}
